import { render, staticRenderFns } from "./ConfirmarIcon.vue?vue&type=template&id=64a953ee"
import script from "./ConfirmarIcon.vue?vue&type=script&lang=ts"
export * from "./ConfirmarIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports